{
	"communities": [
		{
			"name": "Netherlands",
			"country_local": "Nederland",
			"lat": 52,
			"lon": 5.6,
			"link": "https://chat.whatsapp.com/EOGvhoPCiCqDqwuf9JUxtB"
		},
		{
			"name": "Serbia",
			"country_local": "Srbija",
			"lat": 44,
			"lon": 21,
			"link": "https://pauseai.rs/"
		},
		{
			"name": "United Kingdom",
			"lat": 54.2,
			"lon": -2.4,
			"link": "https://pauseai.uk/"
		},
		{
			"name": "France",
			"lat": 47.8,
			"lon": 2.6,
			"link": "https://pauseia.fr"
		},
		{
			"name": "Canada",
			"lat": 56,
			"lon": -105,
			"link": "https://pauseai.ca/en/"
		},
		{
			"name": "Romania",
			"country_local": "România",
			"lat": 44.5,
			"lon": 26,
			"link": "https://www.facebook.com/people/Pause-AI-Romania/61581783381263/?rdid=LfnCxIeWHG9TL4Bp&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F19yinn6qj4%2F"
		},
		{
			"name": "Kenya",
			"lat": 0.5,
			"lon": 38,
			"link": "https://x.com/Pauseaikenya"
		},
		{
			"name": "Spain",
			"country_local": "España",
			"lat": 41.3,
			"lon": -4,
			"link": "https://pauseai.es"
		},
		{
			"name": "Australia",
			"lat": -25,
			"lon": 134.5,
			"link": "https://pauseai.info/australia"
		},
		{
			"name": "Germany",
			"country_local": "Deutschland",
			"lat": 51.1,
			"lon": 10,
			"link": "https://pause-ai.de/"
		},
		{
			"name": "Czechia",
			"lat": 50,
			"lon": 15,
			"link": "https://www.pauseai.cz/"
		},
		{
			"name": "Poland",
			"country_local": "Polska",
			"lat": 52,
			"lon": 19.5,
			"link": "mailto:patryk@pauseai.info"
		},
		{
			"name": "Nigeria",
			"lat": 9.5,
			"lon": 8,
			"link": "https://chat.whatsapp.com/L4o2IiOX1HI2GWQi0J9ZJv"
		},
		{
			"name": "Sweden",
			"country_local": "Sverige",
			"lat": 65,
			"lon": 17,
			"link": "https://pauseai.se/"
		},
		{
			"name": "Italy",
			"country_local": "Italia",
			"lat": 42.5,
			"lon": 12.5,
			"link": "$$WHATSAPP_ITALY$$"
		}
	]
}
